import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { getCountryByHostname } from '@/helpers/country';
import { Routes } from '@/router';
import { isLoyaltyEnabled } from '@/helpers/country';
import { ReferAFriendLinkOpenedContentFragment } from '@/models/cms';

@Component({
  name: 'CmgCreateAccountPage',
})
export default class CmgCreateAccountPage extends Vue {
  currentCountry = this.$appStore.state.ui.countryProfile.countryCode;
  showForm = true; // a flag to toggle animation when swapping country
  referAFriendLinkOpened: ReferAFriendLinkOpenedContentFragment = {};

  get isRewardsReferralProgramEnabled(): boolean {
    return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
  }

  @Watch('isRewardsReferralProgramEnabled', { immediate: true })
  async onRewardsReferralProgramEnabledChange(newValue: boolean) {
    if (newValue) {
      await this.$services.config.setReferAFriendLinkOpened();
      this.referAFriendLinkOpened = this.$services.config.getReferAFriendLinkOpened() || {};
    }
  }

  get modalImageSrc(): string {
    let src = '';
    
    if (isLoyaltyEnabled(this.countryCode)) {
      src = this.$services.config.getSignInModal()?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
    } else {
      src = this.$services.config.getSignInModal()?.imageUrl || this.$appStore.state.cms.images.logos.medallion.default;
    }

    return src;
  }

  get countryCode(): string {
    return this.currentCountry;
  }

  get headingText() {
    if (this.$router.currentRoute.name === Routes.VendorCreateAccount) {
      return 'JOIN CHIPOTLE REWARDS';
    } else if (this.showVerifyMobileNumber) {
      return 'VERIFY YOUR PHONE NUMBER';
    } else if (this.$appStore.state.ui.referrerCustomerIdHash && this.isRewardsReferralProgramEnabled) {
      return this.referAFriendLinkOpened.title || 'YOU\'RE INVITED!';
    } else {
      return this.$services.config.getCreateAccountModal()?.heading || 'CREATE AN ACCOUNT';
    }
  }

  get showVerifyMobileNumber(): boolean {
    return this.$appStore.state.ui.showVerifyMobileNumber;
  }

  created() {
    const countryProfile = getCountryByHostname(window.location.hostname);
    if (countryProfile) {
      this.$services.ui.setCountryProfile(countryProfile, false);
      this.currentCountry = this.$appStore.state.ui.countryProfile.countryCode;
    }
  }

  setCurrentCountry(country: string) {
    this.currentCountry = country;
    this.showForm = false;
    this.$nextTick(() => (this.showForm = true));
  }
}
